// extracted by mini-css-extract-plugin
export default {"modalOverlay":"VO-z","modalContent":"WO-z","header":"XO-z","close":"YO-z"};